import { createFileRoute } from "@tanstack/react-router";
import WhenAntidepressantsDontWork from "@/pages/WhenAntidepressantsDontWork";
export const Route = createFileRoute("/when-antidepressants-dont-work")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "When Antidepressants Dont Work | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "When antidepressants don’t work, TMS, SAINT TMS, and SPRAVATO offer new options. Learn about next steps in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "When Antidepressants Dont Work | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "When antidepressants don’t work, TMS, SAINT TMS, and SPRAVATO offer new options. Learn about next steps in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/when-antidepressants-dont-work",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/when-antidepressants-dont-work",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <WhenAntidepressantsDontWork />;
}
